/**
 * 单店营收监控 - 组件默认显示顺序（GIS 与 HIS 对齐：门店信息概览为首卡）
 * 用于 wrapLayout 布局，支持拖拽排序时作为默认顺序
 */
export function mergeComponentOrderWithDefaults(order, defaultList) {
    if (!Array.isArray(defaultList)) {
        return [];
    }
    var allowed = new Set(defaultList);
    var seen = new Set();
    var result = [];
    if (Array.isArray(order) && order.length > 0) {
        for (var _i = 0, order_1 = order; _i < order_1.length; _i++) {
            var id = order_1[_i];
            if (typeof id !== "string" || !allowed.has(id) || seen.has(id))
                continue;
            seen.add(id);
            result.push(id);
        }
    }
    for (var _a = 0, defaultList_1 = defaultList; _a < defaultList_1.length; _a++) {
        var id = defaultList_1[_a];
        if (!seen.has(id)) {
            result.push(id);
        }
    }
    var lead = "store-overview";
    var leadIdx = result.indexOf(lead);
    if (leadIdx > 0) {
        result.splice(leadIdx, 1);
        result.unshift(lead);
    }
    return result;
}
export var DEFAULT_COMPONENT_ORDER = [
    "store-overview",
    "order-traffic",
    "room-status",
    "room-status-recently",
    "room-health",
    "hourly-price-by-room",
    "channel-price",
    "revpar",
    "customer-source",
    "discount-analysis",
    "occupancy-analysis",
    "operation-efficiency",
    "channel-info",
    "channel-analysis",
];
